<template>
    <v-container fill-height fluid>
        <v-row align="center"
            justify="center">
            <v-col align="center">
                <h3 class="display-1 font-weight-light">Selecciona un chat</h3>
            </v-col>
        </v-row>
    </v-container>
    
</template>
<script>
export default {
    name: "RoomNotSelected"
}
</script>